var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSimMts = function SvgSimMts(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg8",
    width: 14,
    height: 14,
    viewBox: "0 0 3.704 3.704",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    strokeWidth: 0.265,
    transform: "translate(0 -293.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect828",
    fill: "#ff001f",
    stroke: "#9f0013",
    strokeLinecap: "round",
    d: "M2.83 293.43H1.533c-.106 0-.156.051-.196.087-.037.033-.597.607-.597.607-.06.059-.079.075-.079.25v2.28c0 .12.095.216.213.216H2.83a.213.213 0 0 0 .213-.215v-3.01a.213.213 0 0 0-.213-.215z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path837",
    fill: "#fff",
    d: "M1.852 294.31c.352 0 .728.638.728 1.19 0 .434-.252.804-.728.804-.477 0-.728-.37-.728-.804 0-.552.376-1.19.728-1.19"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSimMts);
export default ForwardRef;